import API from './api';

class DepartmentService {
  /**
   * Check if a user has authority over a department
   * @param {string} userEmail - The user's email
   * @param {string} department - The department to check
   * @returns {Promise<boolean>} - Whether the user has authority
   */
  static async hasAuthorityOverDepartment(userEmail, department) {
    try {
      const response = await API.post('/api/departments/check-authority', {
        userEmail,
        department
      });
      
      return response.data.hasAuthority;
    } catch (error) {
      console.error('Error checking department authority:', error);
      return false;
    }
  }

  /**
   * Get department management information
   * @param {string} department - The department name
   * @returns {Promise<Object>} - Department management data
   */
  static async getDepartmentManagement(department) {
    try {
      const response = await API.get(`/api/departments/${encodeURIComponent(department)}/management`);
      return response.data.management;
    } catch (error) {
      console.error('Error fetching department management:', error);
      return null;
    }
  }
}

export default DepartmentService;